import api from "@/application";

import {
  SET_NOTES,
  ADD_NOTE,
  UPDATE_NOTE,
  REMOVE_NOTE,
  SET_LOADING,
  SET_ERROR,
  SET_NOTE_WINDOW_SIZE,
  UPDATE_NOTE_WINDOW_SIZE_REQUEST,
  UPDATE_NOTE_WINDOW_SIZE_SUCCESS,
  UPDATE_NOTE_WINDOW_SIZE_FAILURE,
} from "./mutation-types";

const actions = {
  fetchProfileNotes: async ({ commit }, profileId) => {
    commit(SET_LOADING, true);
    commit(SET_ERROR, null);

    try {
      const { data } = await api.notes.getProfileNotes(profileId);
      commit(SET_NOTES, data);
      return data;
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");
      throw e;
    } finally {
      commit(SET_LOADING, false);
    }
  },

  createProfileNote: async ({ commit }, payload) => {
    commit(SET_LOADING, true);
    commit(SET_ERROR, null);

    try {
      const { data } = await api.notes.createNote(payload);

      commit(ADD_NOTE, data);
      return data;
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");
      throw e;
    } finally {
      commit(SET_LOADING, false);
    }
  },

  updateProfileNote: async ({ commit }, payload) => {
    commit(SET_LOADING, true);
    commit(SET_ERROR, null);

    try {
      const { data } = await api.notes.updateNote(payload);

      commit(UPDATE_NOTE, data);
      return data;
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");
      throw e;
    } finally {
      commit(SET_LOADING, false);
    }
  },

  deleteProfileNote: async ({ commit }, payload) => {
    commit(SET_LOADING, true);
    commit(SET_ERROR, null);

    try {
      await api.notes.deleteNote(payload);

      commit(REMOVE_NOTE, payload.proposalNumber);
    } catch (e) {
      commit(SET_ERROR, e?.response?.status || "UNKNOWN");
      throw e;
    } finally {
      commit(SET_LOADING, false);
    }
  },

  setNoteWindowSize: ({ commit }, size) => {
    commit(SET_NOTE_WINDOW_SIZE, size);
  },

  updateNoteWindowSize: async (
    { commit, state, rootGetters },
    { width, height },
  ) => {
    const roundedWidth = Math.round(width);
    const roundedHeight = Math.round(height);

    if (
      state.noteWindowWidth === roundedWidth &&
      state.noteWindowHeight === roundedHeight
    ) {
      return;
    }

    commit(SET_NOTE_WINDOW_SIZE, {
      width: roundedWidth,
      height: roundedHeight,
    });

    commit(UPDATE_NOTE_WINDOW_SIZE_REQUEST);

    try {
      const tableSettingId =
        rootGetters["purchasesTableSettings/tableSettingId"];

      const { data } = await api.notes.updateNoteWindowSize(tableSettingId, {
        noteWindowWidth: roundedWidth,
        noteWindowHeight: roundedHeight,
      });

      commit(UPDATE_NOTE_WINDOW_SIZE_SUCCESS, {
        width: data.noteWindowWidth,
        height: data.noteWindowHeight,
      });
    } catch (e) {
      commit(UPDATE_NOTE_WINDOW_SIZE_FAILURE);
      console.error("Ошибка при сохранении размеров заметки:", e);
    }
  },
};

export default actions;
